var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPensionPlanGrowth = function SvgPensionPlanGrowth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813,
    height: 152,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pension-plan-growth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#320327",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EFEBEE",
    clipPath: "url(#pension-plan-growth_svg__b)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23 69.73h427M83.365 284v-427M189.729 284v-427M297.635 284v-427"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#EFEBEE",
    clipPath: "url(#pension-plan-growth_svg__c)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404 69.73h425M509.866 284v-427M404.556 284v-427M615.733 284v-427M723.133 284v-427"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 378.523,
    cy: -24.148,
    r: 42.378,
    fill: "#FF2E5B",
    transform: "rotate(-6.26 378.523 -24.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.563,
    cy: 121.248,
    r: 42.378,
    fill: "#FF2E5B",
    transform: "rotate(-6.26 193.563 121.248)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.706,
    cy: 61.375,
    r: 42.378,
    fill: "#FF2E5B",
    transform: "rotate(-6.26 466.706 61.375)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.794,
    cy: 90.477,
    r: 42.378,
    fill: "#EFEBEE",
    transform: "rotate(-6.26 414.794 90.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.407,
    cy: 176.663,
    r: 42.378,
    fill: "#EFEBEE",
    transform: "rotate(-6.26 63.407 176.663)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.237,
    cy: 5.67,
    r: 42.378,
    fill: "#FF2E5B",
    transform: "rotate(-6.26 706.237 5.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596.532,
    cy: -18.151,
    r: 42.378,
    fill: "#84687D",
    transform: "rotate(-6.26 596.532 -18.151)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.193,
    cy: 91.305,
    r: 42.378,
    fill: "#84687D",
    transform: "rotate(-6.26 259.193 91.305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-growth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-growth_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-23-143h427v427H-23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-growth_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404-143h425v427H404z"
  })))));
};
export { SvgPensionPlanGrowth as ReactComponent };
export default __webpack_public_path__ + "images/pension-plan-growth.svg";